import Basket from "./Basket";
import ReactDom from "react-dom";
import React from "react";

let items = document.querySelectorAll('.basket-react');
if (items) {
    items.forEach((el) => {

        let items = JSON.parse(el.getAttribute('data-items'));

        ReactDom.render(<Basket items={items}/>, el);
    });
}